export default __webpack_public_path__ + "static/Tendermint-e206f36e24c10b0b3c655c44e1dddd6f.png";